import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDStack,
  FDBackButton,
  FDPrimaryActionButton,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';
import AccountProposalReviewTemplate from 'Views/Page/Content/Templates/AccountProposalReviewTemplate/Content';

export const AccountOpeningV2NonHYAProposalStepLayout = ({ navigateToLink }) => {
  const {
    onSubmit, saving, resource,
  } = useMetaLayoutContext();
  return (
    <FDStack spacing={3} direction="column">
      <AccountProposalReviewTemplate fullWidthLayout={false} />
      <FDStack direction="row" justifyContent="center" alignItems="center" spacing={2}>
        {resource.withRelationship(
          fr.relationships.previousLink.name,
          (rel) => <FDBackButton label="Back" onClick={() => navigateToLink(rel.link('related'))} />,
          () => null,
        )}
        {resource.meta().canSubmit()
          ? (
            <FDPrimaryActionButton
              {...dataAttrs('continue-btn', resource)}
              label="Continue"
              loading={saving}
              onClick={onSubmit}
            />)
          : null}
      </FDStack>
    </FDStack>
  );
};

AccountOpeningV2NonHYAProposalStepLayout.defaultProps = {
};

AccountOpeningV2NonHYAProposalStepLayout.propTypes = {
  navigateToLink: PropTypes.func.isRequired,
};
